import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import AppConfig from 'bxcommon/providers/AppConfig';
import { AMENDMENT_TYPE, STATUS } from 'bxcommon/constants/status.constant';
import { formatDate } from 'bxcommon/helpers/formatDate.helper';
import { getStatusesStringList } from 'bxcommon/helpers/common.helpers';

import './History.scss';

export const History = ({ request, amendments }) => {
  const { t } = useTranslation();

  const statusTypes = useSelector((state) => state.resources.status.data);
  const statuses = useMemo(() => getStatusesStringList(statusTypes), [statusTypes]);

  const { dayMonthYearHourFormat } = AppConfig;

  const getAmendmentTranslationKey = (type) => {
    const typeMap = {
      [AMENDMENT_TYPE.DEFAULT]: 'request.summary.headings.typeAmendment',
      [AMENDMENT_TYPE.RENEWAL]: 'request.summary.headings.typeRenewal',
      [AMENDMENT_TYPE.EMPLOYER_CHANGE]: 'request.summary.headings.typeEmployerChange',
    };
    return typeMap[type] || 'request.summary.headings.typeAmendment';
  };

  const checkStatus = (status) => (statusTypes.find(({ id }) => id === status) || {}).name;

  const initialRequestData = {
    type: t('request.summary.headings.typeInitial'),
    submissionDate: formatDate(request.request_submission_date, dayMonthYearHourFormat),
    approvalDate: formatDate(request.request_approval_date, dayMonthYearHourFormat),
    status: checkStatus(request.status),
    rowClass: statuses[request.status],
  };

  const amendmentRows =
    amendments?.map((amendment) => ({
      type: t(getAmendmentTranslationKey(amendment.type)),
      submissionDate: formatDate(amendment.submitted_date, dayMonthYearHourFormat),
      approvalDate:
        amendment.status === STATUS.APPROVED ? formatDate(amendment.updated_at, dayMonthYearHourFormat) : '-',
      status: checkStatus(amendment.status),
      rowClass: statuses[amendment.status],
    })) || [];

  const data = [
    {
      type: t('request.summary.headings.type'),
      submissionDate: t('request.summary.headings.submissionDate'),
      approvalDate: t('request.summary.headings.approvalDate'),
      status: t('request.summary.headings.status'),
      rowClass: 'status',
    },
    ...amendmentRows,
    initialRequestData,
  ];

  return (
    <div className="history">
      <table>
        <tbody>
          {data.map(
            (historyItem, index) =>
              historyItem && (
                <tr
                  className={classnames('history__row', `history__row--${historyItem.rowClass || 'default'}`)}
                  key={`${historyItem.type}-${index}`}
                >
                  {Object.values(historyItem)
                    .slice(0, -1)
                    .map((main, idx) =>
                      index === 0 ? (
                        <th className="history__cell--title" key={idx}>
                          <div>{main}</div>
                        </th>
                      ) : (
                        <td className="history__cell--values" key={idx}>
                          <div>{main}</div>
                        </td>
                      ),
                    )}
                </tr>
              ),
          )}
        </tbody>
      </table>
    </div>
  );
};

export default History;
